import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import {  Button, TextField } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbarPrint';
import { useNavigate } from 'react-router-dom';

import Autocomplete from '@mui/material/Autocomplete';


import { collection, query, getDocs } from "firebase/firestore"; 
import {db} from "../firebase.js";

import "../App.css"


function SearchHeader ({Heading, data, setFilter, backupData}){


    const [row ,setRows] = React.useState([]);
    const [backupRow, setBackupRows] = React.useState([]);
    const [SerachValue, setSerachValue] = React.useState("");

   React.useEffect(() => {
      setRows(data);
    setBackupRows(backupData);
   })
   


    let filterResults = () => {
    
        let newArray = backupRow.filter(function (el) {
          return el.firstName == SerachValue
        }
        );
        setRows(newArray);
        setFilter(newArray);
      }


  return (
    <div className="Head-Search">
            <h1>
              {}
            </h1>
            <div style={{ width: "400px", display: "flex" }}>
              <Autocomplete
                id="SearchAutoComplete"
                freeSolo
                style={{ width: "300px" }}
                //inputValue={SerachValue}
                onInputChange={async (event, newInputValue) => {
                  await setSerachValue(newInputValue);
                }}
                //value={SerachValue}
                onChange={(event, newValue) => {
                  //setSerachValue(newValue);
                  console.log("VALUE => " + newValue);
                }}
                options={backupRow.map((option) => option.firstName)}
                renderInput={(params) => <TextField {...params} label="Search by Name" />}
              />
              <Button onClick={filterResults}> Search </Button>
            </div>
          </div>
  )

}


export default function ViewAll() {
    const [rows, setRows] = React.useState([])
    const [backupRow, setBackupRows] = React.useState([]);

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      setBackupRows(arr);
      console.log(arr)
  
  }, []);
  
  async function getData (){
    console.log("me chala")
    let arr = []
    let arr2 = []
    const q = query(collection(db, "employee"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  

     arr.forEach((e=>{
        e.rehab.forEach(e2=>{
            if(e2.startDate && !e2.endDate){
                console.log("e2")
                arr2.push(e)
            }
        })
     }))

     arr.sort((a, b) => {
      return a.surName.localeCompare(b.surName);
    });
  
     setRows(arr2)
     setBackupRows(arr2);
  
  }
  
  
  
    const navigate = useNavigate();
    const columns = [
      //{ field: 'id', headerName: 'ID', width: 70 },
      { field: 'firstName', headerName: 'Name', width: 150 },
      { field: 'surName', headerName: 'Surname', width: 150 },
      //{ field: 'lastName', headerName: 'Last Name', width: 150 },
      // {
      //   field: 'age',
      //   headerName: 'Age',
      //   type: 'number',
      // },
      {
          field: 'startDate',
          headerName: 'Start Date',
          // type: 'number',
          width: 170 
          
        },
        { field: 'contact', headerName: 'Contact Number' , width: 150 },
        { field: 'postCode', headerName: 'Post Code' , width: 150 },
        { field: 'DOB', headerName: 'Date of Birth' , width: 150 },
        // {
        //   field: "action",
        //   headerName: "",
        //   sortable: false,
        //   renderCell: (params) => {
        //     const onClick = (e) => {
             
              
        //       navigate("/profile");
        //     };
      
        //     return <Button onClick={onClick} style={{color: "#1c3261"}}>View Details</Button>;
        //   }
        // },
        
    
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profile",{
        state: {
          employee: params.row,
          activeStep: 0,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
          <div style={{ height: 640, width: '100%'}}>

          {/* <SearchHeader Heading="All Beneficiary" data={rows} backupData={backupRow} setFilter={(e) => setRows(e)} /> */}
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
